// src/utils/websocketService.js

let socket = null
let heartbeatInterval = null

// 初始化 WebSocket 连接
export function initWebSocket(url, onMessageCallback) {
  //
  // console.log('initWebSocket:', url)

  // console.log('initWebSocket-socket:', socket)

  if (socket) return // 防止重复初始化

  socket = new WebSocket(url)

  // 连接成功
  socket.onopen = () => {
    console.log('WebSocket connected')

    // 启动心跳检测
    startHeartbeat()
  }

  // 接收消息
  socket.onmessage = (event) => {
    const message = JSON.parse(event.data)
    if (onMessageCallback) {
      onMessageCallback(message)
    }
  }

  // 连接关闭
  socket.onclose = () => {
    console.log('WebSocket disconnected')

    // 停止心跳检测
    const result = stopHeartbeat()
  }

  // 错误处理
  socket.onerror = (error) => {
    console.error('WebSocket error:', error)
  }
}

// 启动心跳检测
function startHeartbeat() {
  heartbeatInterval = setInterval(() => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      console.log('Sending heartbeat...')
      socket.send(JSON.stringify({ type: 'heartbeat' }))
    }
  }, 50000) // 每 50 秒发送一次心跳
}

// 停止心跳检测
function stopHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval)
    heartbeatInterval = null
  }
}

// 发送消息
export function sendWebSocketMessage(message) {
  console.log('Sending message:', message)
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message))
  } else {
    console.warn('WebSocket is not connected')
  }
}

// 关闭 WebSocket 连接
export function closeWebSocket() {
  if (socket) {
    socket.close()
    socket = null
  }

  // 停止心跳检测
  stopHeartbeat()
}
